module.exports = __webpack_public_path__ + "static/media/cmcc-v2-connect.d38ff2ab.png";